import React, { useEffect, useState } from "react";
import { postDxPrincipalDxComplicacionLiquidacionQx, postLiquidacionProcedimientosQx } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaLiquidacionProcedimientoCirugia from "./TablaLiquidacionProcedimientoCirugia";

const ModalLiquidacionProcedimientoCirugia = ({ setmodalOnLiquidacion,item }) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataLiquidacionProcedimiento, setdataLiquidacionProcedimiento]=useState([])
  const [datauser, setdatauser]=useState([])
  //const [dxPrincipal, setdxPrincipal]=useState([])
  //const [dxComplicaciones, setdxComplicaciones]=useState([])
  const [loading,setloading]=useState(false)
  const handleCancelClick = () => {
    setmodalOnLiquidacion(false);
  };
  useEffect(()=>{
    setdatauser(item)
    setloading(false)
    const procedimientos={
      ProEmpCod:usuarioInfo.Empresa ,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod:item.ProCirCod
    }

    
    postLiquidacionProcedimientosQx(procedimientos).then((res)=>{
      console.log(res.data,'data')
      setdataLiquidacionProcedimiento(res.data)
      setloading(true)
    })

    const dxPrincipa={
      CodEmpCod: usuarioInfo.Empresa ,
      CodMcdpto:usuarioInfo.Sede,
      CodCir: item.ProCirCod
    }
    console.log(dxPrincipa,'dxPrincipa')
    postDxPrincipalDxComplicacionLiquidacionQx(dxPrincipa).then((res)=>{
      console.log(res.data,'dolor principal')
      if(res.data.length !== 0){
        console.log('Entroo')
        if(res.data.length > 0){
          // setdxPrincipal(res.data[1])
          // setdxComplicaciones(res.data[0])
        }
      }
      // setdxPrincipal(res.data[1])
      // setdxComplicaciones(res.data[0])
    })
  },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto "
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] mx-auto relative w-auto pointer-events-none  bg-[#f4f6fa]">
        <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              Liquidación procedimiento Cirugía
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          {/* {
            loading? <>
            <Loading/>
            <div className="py-40"></div>
            </>
            : */}

          <div className="flex-auto overflow-y-auto relative p-4">
            <form>
              <div >
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                      defaultValue={item.MPTDoc}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPTele}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.MPNOMC}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Codigo
                    </label>
                    <input
                      defaultValue={item.ProCirCod}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Contrato
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.ProEPS}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Fecha
                    </label>
                    <input
                      disabled={true}
                      defaultValue={item.ProFec.split(' ')[0]}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Principal
                    </label>
                    <input
                      //defaultValue={dxPrincipal.DMCodi}
                      //value={seleccionarMedico.MedCod}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}
                      //defaultValue={item.ProEPS}
                      // value={seleccionarMedico.MMNomM}
                      //defaultValue={dxPrincipal.DMNomb}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex flex-row py-1  text-left">
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Dx Complicación
                    </label>
                    <input
                      //defaultValue={item.ProCirCod}
                      //value={seleccionarMedico.MedCod}
                      //defaultChecked={dxComplicaciones.DMCodi}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium pt-5">
                      
                    </label>
                    <input
                      disabled={true}
                      //defaultChecked={dxComplicaciones.DMNomb}
                      //defaultValue={item.ProEPS}
                      // value={seleccionarMedico.MMNomM}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900"
                            >
                              
                            </th>
                          <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              
                            </th>  
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Proced Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Descripción
                            </th>
                            
                          </tr>
                        </thead>
                        {
                          loading?
                          dataLiquidacionProcedimiento.map((item,index)=>(
                            <TablaLiquidacionProcedimientoCirugia key={index} item={item} dataUser={datauser}/>
                          ))
                          :
                          <tbody className="divide-y divide-slate-700">
                            <tr>
                              <td></td>
                              <td></td>
                              
                              <td><Loading/></td>
                            </tr>
                            </tbody>
                        }
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <h5
            className="text-xl font-medium leading-normal text-gray-800 text-center"
            id="exampleModalScrollableLabel"
          >
            PROCEDIMIENTOS
          </h5> */}
            {/* <div className="">
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-1 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center bg-gray-200">
                        <thead className="">
                          <tr>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Pro
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cons
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              A.Qx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cd.Prc
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Procedimiento
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cant
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Honorario
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod.Med
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Nombre Médico
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Cod. Esp
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Especialidad
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              No Fac?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vr. Hono
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Tmpo
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Participo?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Realizó?
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Docto
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Incluido Flq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Forma Liq
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-4 py-2"
                            >
                              Vrl. Uvr
                            </th>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="w-1/3 p-3">
            <button
                type="submit"
                onClick={handleOnclickAgregarMedicoDQ}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar Médico
              </button>
          </div> */}
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
              type="submit"
              //onClick={handleOnclickDescripcion}
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              confirmar
            </button>
            </div>
          </div>
          {/* } */}
        </div>
      </div>
    </div>
  );
};

export default ModalLiquidacionProcedimientoCirugia;
